import {RsnDialog} from '@raison/ui-kit';
import React from 'react';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '~/shared/store';
import {DialogRegistration} from '../model/DialogRegistration';

export function GlobalDialogs({dialogs}: {dialogs: DialogRegistration[]}) {
    const dispatch = useAppDispatch();
    const opened = useSelector((state: AppModel) => {
        for (const dialog of dialogs) {
            const element = dialog.render(state);

            if (element) {
                return {
                    dialogId: dialog.dialogName,
                    element,
                    onClose: () => dispatch(dialog.close()),
                    implicitClose: () => dispatch(dialog.implicitClose()),
                };
            }
        }
        return null;
    });

    const {dialogId, element, implicitClose} = opened ?? {};

    return (
        <RsnDialog.Controller dialogId={dialogId} onClose={implicitClose}>
            {element}
        </RsnDialog.Controller>
    );
}
